// ------------------------------------
// Constants
// ------------------------------------
// export const FETCH_ICONS = 'FETCH_ICONS'
const iconstore = function reducer(
	state = {
		iconstore: [],
		fetching: false,
		fetched: false,
		error: null
	},
	action
) {
	switch (action.type) {
		case 'FETCH_ICONS': {
			return { ...state, fetching: true }
		}
		case 'FETCH_ICONS_REJECTED': {
			return { ...state, fetching: false, error: action.payload }
		}
		case 'ICON_DELETE_FULFILLED': {
			return {
				...state,
				iconstore: action.payload
			}
		}
		case 'NEW_ICONS_FULFILLED': {
			return {
				...state,
				fetching: true,
				fetched: true,
				iconstore: action.payload
			}
		}
		case 'FETCH_ICONS_FULFILLED': {
			return {
				...state,
				fetching: true,
				fetched: true,
				iconstore: action.payload
			}
		}
	}
	return state
}
export default iconstore
